import { Calendar } from 'primereact/calendar';

const CustomDatePicker = ({
	value,
	setValue,
	name,
	label,
	size,
	filterDate,
	minDateField,
	className,
	onChange,
	labelClassName,
	important,
	minDate = null,
	error = false,
	errorText = '',
	maxDateField = null,
	showIcon = true,
	...props
}) => {
	return (
		<div className={'flex w-full h-full'}>
			<Calendar
				showButtonBar
				id='icon'
				className={
					(error && errorText ? 'p-invalid' : '') +
					' !border-none !outline-none !p-0 !text-base !font-input-font-family !w-full lg:!text-xs'
				}
				panelClassName={`!w-[408px]`}
				value={value}
				onChange={setValue}
				//minDate={minDate !== null ? minDate : null}
				todayButtonClassName='hidden'
				dateFormat='dd-MM-yy'
				showIcon={showIcon}
				placeholder={label}
				name={name}
				locale='es'
				{...props}
        readOnlyInput
			/>

			{error && errorText && (
				<small htmlFor={name} className='p-error block !font-input-font-family'>
					{errorText}
				</small>
			)}
		</div>
	);
};

export default CustomDatePicker;
